import { render, staticRenderFns } from "./ImportItem.vue?vue&type=template&id=79f75d96&"
import script from "./ImportItem.vue?vue&type=script&lang=ts&"
export * from "./ImportItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports